import { render, staticRenderFns } from "./OnboardIndex.vue?vue&type=template&id=1d6a8914&scoped=true"
import script from "./OnboardIndex.vue?vue&type=script&lang=js"
export * from "./OnboardIndex.vue?vue&type=script&lang=js"
import style0 from "./OnboardIndex.vue?vue&type=style&index=0&id=1d6a8914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a8914",
  null
  
)

export default component.exports